import { query } from '@confluence/query-preloader-tools';

import { FEATURE_DISCOVERY_CONTEXTUAL_CREATE_MENU_SUBTEXT } from '../../constants/onboarding-state/onboarding-constants';

import { getOnboardingStateGQL } from './OnboardingStatus.graphql';

export const preloadContextualCreateSubtextEnrollment = () => {
	return query({
		query: getOnboardingStateGQL,
		variables: {
			key: [...Object.values(FEATURE_DISCOVERY_CONTEXTUAL_CREATE_MENU_SUBTEXT)],
		},
	});
};
